/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Court_NextInputs */

const th_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถัดไป`)
};

const en_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const ja_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次`)
};

const zh_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一场`)
};

const es_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente`)
};

const pt_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo`)
};

const id_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berikutnya`)
};

const fr_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivant`)
};

const tl_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susunod`)
};

const vi_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kế tiếp`)
};

const ko_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음`)
};

const de_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Nächstes`)
};

const ru_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Далее`)
};

const tr_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sırada`)
};

const it_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossima`)
};

const pl_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następny`)
};

const uk_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Далі`)
};

const hi_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगला`)
};

const ar_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التالي`)
};

const ms_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seterusnya`)
};

const bn_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পরবর্তী`)
};

const zh_tw2_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一場`)
};

const zh_hk2_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一場`)
};

const ur_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اگلا`)
};

const fa_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بعدی`)
};

const sw_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inayofuata`)
};

const nl_court_next = /** @type {(inputs: Court_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hierna`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Court_NextInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const court_next = /** @type {((inputs?: Court_NextInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Court_NextInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_court_next(inputs)
	if (locale === "ja") return ja_court_next(inputs)
	if (locale === "zh") return zh_court_next(inputs)
	if (locale === "es") return es_court_next(inputs)
	if (locale === "pt") return pt_court_next(inputs)
	if (locale === "id") return id_court_next(inputs)
	if (locale === "fr") return fr_court_next(inputs)
	if (locale === "tl") return tl_court_next(inputs)
	if (locale === "vi") return vi_court_next(inputs)
	if (locale === "ko") return ko_court_next(inputs)
	if (locale === "de") return de_court_next(inputs)
	if (locale === "ru") return ru_court_next(inputs)
	if (locale === "tr") return tr_court_next(inputs)
	if (locale === "it") return it_court_next(inputs)
	if (locale === "pl") return pl_court_next(inputs)
	if (locale === "uk") return uk_court_next(inputs)
	if (locale === "hi") return hi_court_next(inputs)
	if (locale === "ar") return ar_court_next(inputs)
	if (locale === "ms") return ms_court_next(inputs)
	if (locale === "bn") return bn_court_next(inputs)
	if (locale === "zh-TW") return zh_tw2_court_next(inputs)
	if (locale === "zh-HK") return zh_hk2_court_next(inputs)
	if (locale === "ur") return ur_court_next(inputs)
	if (locale === "fa") return fa_court_next(inputs)
	if (locale === "sw") return sw_court_next(inputs)
	if (locale === "nl") return nl_court_next(inputs)
	return en_court_next(inputs)
});